import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, ISelectCardOperation, ISelectCardOption } from "../../../constants/types";
import Icon from "../../icon/Icon";

import './SelectCardOperation.scss'
import { t } from "i18next";

interface Props extends WithTranslation{
    operation: ISelectCardOperation,
    data: IOperationData
};

class SelectCardOperationMinimized extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const { t, operation, data } = this.props;

        const res = operation.options.filter((op) => op.id === data?.value)[0]?.name;

        return <div className="render-select-card-operation" >
            {t(res as unknown as TemplateStringsArray)}
        </div>;
    }
};

export default withTranslation()(SelectCardOperationMinimized);